import './schduledTaskTrigger.scss';

const moment = require('moment-timezone');

export class ScheduledTaskTrigger {
    constructor($scope, $mdDialog, schedule, trigger, SchedulesService, STRATEGIES_ENUM, TRIGGER_TYPES, ZONE_IDS) {

        trigger = Object.assign({}, trigger);

        let zone_ids = ZONE_IDS;

        trigger.strategy = trigger.strategy ? trigger.strategy : STRATEGIES_ENUM.RUN_INDEFINITELY.value;
        $scope.TRIGGER_TYPES = TRIGGER_TYPES;
        $scope.trigger = trigger;
        $scope.updateFutureDates = updateFutureDates;
        $scope.showFutureDatesLoader = true;
        $scope.searchTimezoneChange = searchTimezoneChange;
        $scope.selectedTimezoneChange = selectedTimezoneChange;
        $scope.searchTimezones = searchTimezones;
        $scope.cancellChanges = cancellChanges;

        $scope.zoneDiff = getTimeNumberZone();

        updateFutureDates(trigger);

        initializeTimeZone($scope.trigger.zoneId);

        $scope.searchText = "Central Standard Time";

        $scope.saveTrigger = (t) => {
            saveTrigger(t, (resp) => {
                if (resp.status === 200) {
                    $scope.trigger = resp.data;
                    $mdDialog.hide(resp.data);
                }
            });
        };

        $scope.cancelChanges = () => {
            $mdDialog.cancel()
        };

        function getTimeNumberZone() {
            return moment().tz($scope.trigger.zoneId).format('Z').replace(':','');
        }

        function searchTimezones(query) {
            return zone_ids
                .filter((z_id) => z_id.text.indexOf(query) !== -1)
                .sort((z_id) => {
                    return -z_id.text.indexOf(query);
                    // return z_id.text.startsWith(query) || z_id.display.split("/").some((s) => s.startsWith(query));
                });
        }

        function initializeTimeZone(TimeZone) {
            let foundedTimeZone = findZoneFromListOfZones(TimeZone);
            if (foundedTimeZone) {
                $scope.timezone = {
                    value: foundedTimeZone.value,
                    display: foundedTimeZone.display,
                    text: foundedTimeZone.text
                };
            } else {
                $scope.timezone = {
                    value: "Central Standard Time",
                    display: "America/Chicago",
                    text: "(UTC-06:00) Central Time (US & Canada)"
                }
            }
        }

        function findZoneFromListOfZones(TimeZone) {
            return zone_ids
                .find((z_id) => z_id.value.indexOf(TimeZone) !== -1);
        }

        function selectedTimezoneChange(tz) {
            if (tz) {
                $scope.trigger.zoneId = tz.value;
                $scope.zoneDiff = getTimeNumberZone();
            }
        }

        function searchTimezoneChange(text) {
            console.log(text);
        }


        function cancellChanges() {
            $mdDialog.cancel();
        }

        function saveTrigger(trigger, callback) {
            $scope.showFutureDatesLoader = true;
            SchedulesService
                .saveTrigger(schedule, trigger)
                .then((resp) => {
                    $scope.showFutureDatesLoader = false;
                    callback(resp);
                })
        }

        function updateFutureDates(trigger, save = false) {
            $scope.showFutureDatesLoader = true;
            if (trigger.id || save) {
                let callback = (data) => {
                    $scope.trigger.futureDates = data;
                    $scope.showFutureDatesLoader = false;
                };
                if (save && !trigger.id) {
                    saveTrigger(trigger, (resp) => {
                        if (resp.status === 200)
                            getFutureDates(resp.data, callback);
                    });
                } else {
                    getFutureDates(trigger, callback);
                }
            }
        }

        function getFutureDates(trigger, callback) {
            SchedulesService
                .pullNextDates(trigger)
                .then((resp) => {
                    if (resp.status === 200) {
                        callback(resp.data);
                    }
                });
        }
    }

    static getInstance = (event, trigger, schedule) => {
        return {
            controller: ['$scope', '$mdDialog', 'schedule', 'trigger', 'SchedulesService', 'STRATEGIES_ENUM', 'TRIGGER_TYPES', 'ZONE_IDS', ScheduledTaskTrigger],
            template: require('./scheduledTaskTrigger.html'),
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {'trigger': trigger, 'schedule': schedule},
            fullscreen: true
        }
    }

}


